export default "__VITE_ASSET__ef91061f__"